import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useTheme, styled, Grid } from "@mui/material";
import { AnalyticsTrackingEvent } from "../../analytics/events.js";
import brandclub_colors from "../../colors/brandclubColors.js";
import { sendTextCallback } from "../../utils/textMessage.js";
import BrandclubPhoneInput, { BCPhoneInputVariant } from "../components/BrandclubPhoneInput/index.js";
import { GenericContainer } from "../components/GenericContainer.js";
import { SiteBrandingType } from "../type.js";
import { UNIVERSAL_STORE_SITE, MOBILE_HORIZONTAL_PADDING, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, TABLET_SCREEN_SIZE, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from "../../utils/constants/Constants.js";
import { YoutubeIcon } from "../../assets/svg/footer_youtube.js";
import { InstagramIcon } from "../../assets/svg/footer_instergram.js";
import { FacebookIcon } from "../../assets/svg/footer_facebook.js";
import { TiktokIcon } from "../../assets/svg/footer_tiktok.js";
import { TwitterIcon } from "../../assets/svg/footer_twitter.js";
import { PinterestIcon } from "../../assets/svg/footer_pinterest.js";
const isDefined = (value) => value != null;
const FooterContainer = styled(GenericContainer)({
  zIndex: 1,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: `0 5%`,
  boxSizing: "border-box",
  backgroundColor: brandclub_colors.blueWhite,
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    padding: `0 ${TABLET_HORIZONTAL_PADDING}px`
  },
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    padding: `0 ${MOBILE_HORIZONTAL_PADDING}px`
  }
});
const GetTheAppTitle = styled("div")(({ theme }) => ({
  fontSize: 16,
  fontWeight: 600,
  paddingBottom: 12,
  color: theme.vars.palette.text.primary,
  maxWidth: 301
}));
const FooterContentContainer = styled(Grid)(({ theme }) => ({
  "&.last-footer-content": {
    borderTop: "1px solid #e5e5e5"
  },
  padding: "54px 0",
  maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
  width: "100%",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  ".invite_sec": {
    flex: 4,
    minWidth: 300,
    ".brandName": {
      fontSize: 20,
      fontWeight: 700,
      paddingBottom: 12,
      color: theme.vars.palette.text.primary,
      maxWidth: 301
    },
    ".subtitle": {
      fontSize: 14,
      fontWeight: 500,
      paddingBottom: 30,
      color: theme.vars.palette.text.primary,
      maxWidth: 286
    },
    ".phone_input": {
      maxWidth: 285
    }
  },
  ".links": {
    flex: 6,
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      flexDirection: "column",
      gap: 40
    }
  },
  ".links_sec": {
    minWidth: 160,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    ".label": {
      display: "flex",
      alignItems: "center",
      gap: 12
    },
    ".header": {
      fontSize: 16,
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      textAlign: "left",
      color: theme.vars.palette.text.primary
    },
    a: {
      textDecoration: "none",
      fontSize: 14,
      maxWidth: 200,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      marginTop: 15,
      letterSpacing: "normal",
      textAlign: "left",
      color: theme.vars.palette.text.primary,
      [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        marginTop: 7,
        marginBottom: 3
      },
      [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
        marginTop: 7,
        marginBottom: 3
      }
    },
    ".desc": {
      fontSize: 16,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      marginTop: 14,
      marginBottom: 6,
      letterSpacing: "normal",
      textAlign: "left",
      color: theme.vars.palette.text.primary
    },
    input: {
      marginTop: 18,
      marginBottom: 14,
      width: 260,
      height: 42,
      borderRadius: 10,
      color: theme.vars.palette.text.primary,
      outline: "none",
      paddingLeft: "20px",
      fontSize: 14,
      border: `solid 1px ${theme.vars.palette.primary.main}`,
      backgroundColor: "#ffffff"
    },
    "::placeholder": {
      color: theme.vars.palette.text.primary,
      opacity: 1
    },
    button: {
      marginTop: 6,
      height: 41,
      width: 144,
      color: "white",
      border: "none",
      outline: "none",
      fontSize: 18,
      fontWeight: 500,
      cursor: "pointer",
      borderRadius: 50,
      position: "relative",
      backgroundColor: "#16949b"
    }
  },
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    flexDirection: "column",
    padding: "40px 0",
    gap: 40,
    ".links_sec": {}
  }
}));
const BottomBarContainer = styled(Grid)(({ theme }) => ({
  borderTop: "1px solid #e5e5e5",
  maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: "row",
  ".bot_nav": {
    display: "flex",
    flxDirecton: "row",
    gap: 50,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      flexDirection: "column",
      gap: 15
    },
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      flexDirection: "column",
      gap: 15
    },
    a: {
      fontSize: 12,
      fontWeight: 500,
      color: theme.vars.palette.text.primary,
      textDecoration: "none"
    }
  },
  ".medias": {
    display: "flex",
    whiteSpace: "nowrap",
    a: {
      margin: "0 0 0 20px",
      width: 24,
      height: 24
    },
    img: {
      width: 24,
      height: 24
    }
  },
  padding: "30px 0 50px 0",
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    alignItems: "flex-start",
    flexDirection: "column-reverse",
    ".medias": {
      marginBottom: 30,
      a: {
        margin: "0 10px 0 0"
      }
    }
  }
}));
const BrandLogo = styled("div")({
  marginBottom: 20,
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    position: "relative",
    top: "unset",
    left: "unset",
    maxWidth: 75
  },
  img: {
    objectFit: "contain",
    maxWidth: 125,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      maxWidth: 75
    }
  }
});
const LinkOffsetPill = styled("div")(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  paddingBottom: 12,
  backgroundColor: theme.vars.palette.primary.main,
  color: "#ffffff",
  height: 24,
  padding: "0 13px",
  display: "flex",
  alignItems: "center",
  borderRadius: 200
}));
const SingleFooter = ({
  axios,
  LinkComponent,
  brandEntity,
  footerConfig,
  className,
  userProfile,
  trackingParams
}) => {
  var _a, _b, _c, _d;
  if (footerConfig == null ? void 0 : footerConfig.hideBrandSection) {
    return null;
  }
  return /* @__PURE__ */ jsxs(FooterContentContainer, { className, children: [
    (footerConfig == null ? void 0 : footerConfig.siteBrandingType) === SiteBrandingType.UniversalStore ? /* @__PURE__ */ jsxs("div", { className: "invite_sec", children: [
      /* @__PURE__ */ jsx("div", { className: "logo", children: /* @__PURE__ */ jsx(BrandLogo, { children: /* @__PURE__ */ jsx(LinkComponent, { to: "/", children: /* @__PURE__ */ jsx(
        "img",
        {
          loading: "lazy",
          src: "https://media.brandclub.com/brandclub/image_asset/brandclub_logo_no_star.svg",
          alt: "bd_logo"
        }
      ) }) }) }),
      /* @__PURE__ */ jsx(
        GetTheAppTitle,
        {
          className: "title",
          sx: {
            paddingBottom: userProfile ? "30px" : void 0
          },
          children: "Download the app to access rewards"
        }
      ),
      !userProfile && /* @__PURE__ */ jsx("div", { className: "subtitle", children: "Enter your mobile number to get started." }),
      /* @__PURE__ */ jsx("div", { className: "phone_input", children: /* @__PURE__ */ jsx(
        BrandclubPhoneInput,
        {
          userProfile,
          hasHeader: false,
          buttonText: "Send",
          variant: BCPhoneInputVariant.DRAWER_MOBILE,
          handleSendText: async (phoneNumber) => {
            return sendTextCallback(
              phoneNumber,
              axios,
              brandEntity,
              void 0,
              trackingParams,
              AnalyticsTrackingEvent.WEB_APP_SOCIAL_LINK_TEXT_APP_DOWNLOAD_LINK
            );
          }
        }
      ) })
    ] }) : (footerConfig == null ? void 0 : footerConfig.siteBrandingType) === SiteBrandingType.CustomDTCStore ? /* @__PURE__ */ jsxs("div", { className: "invite_sec", children: [
      /* @__PURE__ */ jsx("div", { className: "brandName", children: (_a = brandEntity == null ? void 0 : brandEntity.entity) == null ? void 0 : _a.name }),
      /* @__PURE__ */ jsx("div", { className: "subtitle", children: footerConfig.customText })
    ] }) : /* @__PURE__ */ jsxs("div", { className: "invite_sec", children: [
      /* @__PURE__ */ jsx("div", { className: "brandName", children: (_b = brandEntity == null ? void 0 : brandEntity.entity) == null ? void 0 : _b.name }),
      /* @__PURE__ */ jsx("div", { className: "subtitle", children: `Earn rewards with ${(_c = brandEntity == null ? void 0 : brandEntity.entity) == null ? void 0 : _c.name} by completing activities, making purchases,
and syncing your accounts.` })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "links", children: (_d = footerConfig == null ? void 0 : footerConfig.linkSections) == null ? void 0 : _d.map((section, idx) => {
      var _a2;
      return /* @__PURE__ */ jsxs("div", { className: "links_sec", children: [
        section.title && /* @__PURE__ */ jsx("div", { className: "header", children: section.title }),
        (_a2 = section == null ? void 0 : section.links) == null ? void 0 : _a2.map((link) => /* @__PURE__ */ jsx(LinkComponent, { to: link.link, onClick: link.onClick, children: /* @__PURE__ */ jsxs("div", { className: "label", children: [
          /* @__PURE__ */ jsx("div", { className: "label_text", children: link.label }),
          link.offsetText ? /* @__PURE__ */ jsx(LinkOffsetPill, { children: link.offsetText }) : null
        ] }) }, `${link.label}-${section.title}`))
      ] }, section.title ?? idx);
    }) })
  ] });
};
const BrandclubFooter = ({
  axios,
  LinkComponent,
  brandEntity,
  footerConfigs,
  className,
  userProfile,
  socialLinks,
  PhoneInputComponent
}) => {
  var _a, _b, _c;
  const theme = useTheme();
  const linkPrefix = ((_a = footerConfigs == null ? void 0 : footerConfigs[0]) == null ? void 0 : _a.siteBrandingType) === SiteBrandingType.CustomDTCStore ? UNIVERSAL_STORE_SITE : "";
  return /* @__PURE__ */ jsxs(FooterContainer, { className: "brandclub-footer " + className, children: [
    footerConfigs == null ? void 0 : footerConfigs.filter(isDefined).map((footerConfig, index, allConfigs) => {
      return /* @__PURE__ */ jsx(
        SingleFooter,
        {
          axios,
          LinkComponent,
          brandEntity,
          footerConfig,
          userProfile,
          PhoneInputComponent,
          className: allConfigs.length > 1 && allConfigs.length - 1 === index ? "last-footer-content" : ""
        },
        footerConfig.siteBrandingType
      );
    }),
    /* @__PURE__ */ jsxs(BottomBarContainer, { children: [
      /* @__PURE__ */ jsxs("div", { className: "bot_nav", children: [
        ((_b = footerConfigs == null ? void 0 : footerConfigs[0]) == null ? void 0 : _b.siteBrandingType) === SiteBrandingType.CustomDTCStore || ((_c = footerConfigs == null ? void 0 : footerConfigs[0]) == null ? void 0 : _c.siteBrandingType) === SiteBrandingType.CustomStore ? null : /* @__PURE__ */ jsxs(LinkComponent, { to: `/`, children: [
          "© ",
          (/* @__PURE__ */ new Date()).getFullYear(),
          " Brandclub"
        ] }),
        /* @__PURE__ */ jsx(LinkComponent, { to: `${linkPrefix}/privacy`, children: "Privacy Policy" }),
        /* @__PURE__ */ jsx(LinkComponent, { to: `${linkPrefix}/californiaprivacy`, children: "California Policy" }),
        /* @__PURE__ */ jsx(LinkComponent, { to: `${linkPrefix}/terms`, children: "Terms of Service" }),
        /* @__PURE__ */ jsx(LinkComponent, { to: `${linkPrefix}/endorsement`, children: "Endorsement" }),
        /* @__PURE__ */ jsx(LinkComponent, { to: `${linkPrefix}/rewardterms`, children: "Reward Terms" })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "medias", children: /* @__PURE__ */ jsxs(Fragment, { children: [
        (socialLinks == null ? void 0 : socialLinks.youtube) && /* @__PURE__ */ jsx("a", { href: socialLinks.youtube, target: "blank", className: "social-links", title: "YouTube", children: /* @__PURE__ */ jsx(YoutubeIcon, { fill: theme.dtcMode ? theme.vars.palette.primary.main : void 0 }) }),
        (socialLinks == null ? void 0 : socialLinks.instagram) && /* @__PURE__ */ jsx("a", { href: socialLinks == null ? void 0 : socialLinks.instagram, target: "blank", title: "Instagram", children: /* @__PURE__ */ jsx(InstagramIcon, { fill: theme.dtcMode ? theme.vars.palette.primary.main : void 0 }) }),
        (socialLinks == null ? void 0 : socialLinks.facebook) && /* @__PURE__ */ jsx("a", { href: socialLinks == null ? void 0 : socialLinks.facebook, target: "blank", title: "Facebook", children: /* @__PURE__ */ jsx(FacebookIcon, { fill: theme.dtcMode ? theme.vars.palette.primary.main : void 0 }) }),
        (socialLinks == null ? void 0 : socialLinks.tiktok) && /* @__PURE__ */ jsx("a", { href: socialLinks == null ? void 0 : socialLinks.tiktok, target: "blank", title: "TikTok", children: /* @__PURE__ */ jsx(TiktokIcon, { fill: theme.dtcMode ? theme.vars.palette.primary.main : void 0 }) }),
        (socialLinks == null ? void 0 : socialLinks.x) && /* @__PURE__ */ jsx("a", { href: socialLinks == null ? void 0 : socialLinks.x, target: "blank", title: "X", children: /* @__PURE__ */ jsx(TwitterIcon, { fill: theme.dtcMode ? theme.vars.palette.primary.main : void 0 }) }),
        (socialLinks == null ? void 0 : socialLinks.pinterest) && /* @__PURE__ */ jsx("a", { href: socialLinks == null ? void 0 : socialLinks.pinterest, target: "blank", title: "Pinterest", children: /* @__PURE__ */ jsx(PinterestIcon, { fill: theme.dtcMode ? theme.vars.palette.primary.main : void 0 }) })
      ] }) })
    ] })
  ] });
};
export {
  BrandclubFooter
};
//# sourceMappingURL=index.js.map
